import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TagBloc } from '@kbloc';
import { LegalDocumentsBloc } from '@kp/legal-document/legal-documents.bloc';
import { OnboardingBloc } from '@kp/onboarding/onboarding.bloc';
import { TraitsBloc } from '@kp/traits/traits.bloc';
import { ThemeService, TitleService } from '@kservice';
import { UserType } from '@ktypes/enums';
import { Status } from '@ktypes/models';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kp-screen-pre-signup',
  templateUrl: './screen-pre-signup.component.html',
  styleUrls: ['./screen-pre-signup.component.scss'],
})
export class ScreenPreSignupComponent implements OnInit, OnDestroy {
  private _destroy$ = new Subject<void>();
  private _title = 'Signup/Login';

  constructor(
    private _legalDocumentsBloc: LegalDocumentsBloc,
    private _onboardingBloc: OnboardingBloc,
    private _router: Router,
    private _tagBloc: TagBloc,
    public themeService: ThemeService,
    private _titleService: TitleService,
    private _traitsBloc: TraitsBloc
  ) {}

  ngOnInit() {
    this._titleService.set(this._title);

    // clear this so previously set legal documents statuses & storage are cleared prior to privacy page (next)
    this._legalDocumentsBloc.clearLegalDocumentStatus();
    this._legalDocumentsBloc.clearLegalDocumentStorage();

    this._onboardingBloc.guestUserDataStatus$.pipe(takeUntil(this._destroy$)).subscribe((dataStatus) => {
      if (dataStatus?.status === Status.error) {
        void this._router.navigate(['/welcome/error']);
      } else if (dataStatus?.status === Status.done && dataStatus?.data?.user?.type === UserType.guest) {
        // populate Traits and Tags
        this._traitsBloc.refreshTraits();
        this._tagBloc.getUserTags();
        // continue on to create an account
        void this._router.navigate(['/welcome/privacy']);
      }
    });
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  signUp() {
    // TODO: remove if Guest or Onboarding users are eliminated
    this._onboardingBloc.createGuestUser();
  }
}
